import { TFunction, TOptions } from 'i18next';

/**
 * @deprecated use `useCustomTranslation` hook instead
 */
export const getTranslation =
  (t: TFunction, base: string) =>
  (key: string, options: TOptions = {}) =>
    t([base, key].join('.'), options);
